import { Injectable } from '@angular/core';
import { WOW } from 'wowjs/dist/wow.min';


@Injectable()
export class WowJsService {
  public wow;

  constructor() {

  }

  init() {
    this.wow = new WOW({
      live: false
    });

    this.wow.init();

  }

  play() {
    this.wow.scrolled = true;
    this.wow.sync();
    this.wow.start();
  }

}



// WEBPACK FOOTER //
// ./src/app/core.module/services/wowjs.service.ts